import React from "react";
import "./styles.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Footer() {
  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  return (
    <div className="footer">
      <h2 className="logo" onClick={() => topFunction()}>
        CryptoStream<span>.</span>
      </h2>
      <div className="social-links">
        <a href="mailto:khan.abdul.7071@gmail.com">
          <EmailIcon className="social-link" />
        </a>
        <a href="https://linkedin.com/in/khanabdulrehman" target="_blank">
          <LinkedInIcon className="social-link" />
        </a>
        <a href="https://github.com/abdulRehman7071" target="_blank">
          <GitHubIcon className="social-link" />
        </a>
        {/* <a href="https://twitter.com/abdulRehman7071">
          <TwitterIcon className="social-link" />
        </a> */}
      </div>
    </div>
  );
}

export default Footer;
